import { useState } from "react"
import {
  TooltipButton,
  type TooltipButtonProps,
} from "@/v2-backoffice-client/components/button"
import MigrationCenterDialog from "@/v2-backoffice-client/tenant/migration/center/MigrationCenterDialog"

export type TenantMigrateButtonProps = Omit<
  TooltipButtonProps,
  "content" | "onClick"
> & {
  tenantId: number
  tenantName?: string
  customerName?: string | null
}

// Opens the Migration Center for one team — the team panel's Fusion Login
// button. Same dialog as the table selections (FUS-927): member table with
// per-member sends, the team wave, and the live progress bar.
function TenantMigrateButton(props: TenantMigrateButtonProps) {
  const {
    tenantId,
    tenantName,
    customerName,
    children,
    ...tooltipButtonProps
  } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <TooltipButton
        variant="ghost"
        size="tiny"
        iconSrc="key"
        content="Migrate this team to Fusion login: create accounts and email every member a personal activation link."
        isSquare={!children}
        onClick={(e) => {
          e.stopPropagation()
          setIsOpen(true)
        }}
        {...tooltipButtonProps}
      >
        {children}
      </TooltipButton>

      <MigrationCenterDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        selection={{
          kind: "tenants",
          tenants: [
            {
              Id: tenantId,
              Name: tenantName ?? `Team #${tenantId}`,
              CustomerName: customerName,
            },
          ],
        }}
      />
    </>
  )
}

export default TenantMigrateButton
